import Borrower from "./Borrower.jsx";

export default Borrower;
